import { useContext, useMemo, type FC } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import { createTrialItemsSubMenu } from "src/routing/navigation";

/**
 * Registers the trial items submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * A missing or zero trial ID renders nothing; factory results are memoized by identity reference.
 */
const TrialItemsSubMenu: FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);

    const subMenu = useMemo(
        () => (trialIdentity?.id ? createTrialItemsSubMenu(trialIdentity.id) : undefined),
        [trialIdentity]
    );

    return subMenu ? <AddPageSubMenu subMenu={subMenu} /> : null;
};

export default TrialItemsSubMenu;
